import { render } from "./GroupComponent.vue?vue&type=template&id=14b68b30&scoped=true"
import script from "./GroupComponent.vue?vue&type=script&lang=js"
export * from "./GroupComponent.vue?vue&type=script&lang=js"

import "./GroupComponent.vue?vue&type=style&index=0&id=14b68b30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b68b30"]])

export default __exports__